import { AppdataService } from 'src/app/services/app-data/appdata.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LivechatStatusComponent } from './components/livechat-status/livechat-status.component';
// import { CommonFeaturesModule } from './common-features/common-features.module';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { AudiorecordingService } from './services/audio-recording/audiorecording.service';
import { ChatqueueService } from './services/chatqueue/chatqueue.service';
import { CommunicationInterfaceService } from './services/communicationInterface/communication-interface.service';
import { FileTransferService } from './services/file-transfer/file-transfer.service';
import { LivechatStartService } from './services/livechat-start/livechat-start.service';
import { MessengerService } from './services/messenger/messenger.service';
import { WebsocketService } from './services/websockets/websocket.service';
import { SharedModule } from './shared/shared.module';
import { MatSelectModule } from '@angular/material/select';
import { TRANSLOCO_CONFIG, TranslocoConfig, TranslocoModule } from '@ngneat/transloco';
import { translocoLoader } from './transloco.loader';
import { CustomTooltipDirective } from './directives/custom-tooltip.directive';
declare var translocoConfig: any;

export function checkQueryParamsChange(livechatStartService: LivechatStartService) {
  return async () => await livechatStartService.checkQueryParamsChange()
}

export function appendSourceFiles(appDataService: AppdataService) {
  return async () => await appDataService.appendSourceFiles()
}

@NgModule({
  declarations: [AppComponent, WelcomeComponent, ThankYouComponent, LivechatStatusComponent],
  imports: [
    TranslocoModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSnackBarModule,
    DragDropModule,
    HttpClientModule,
    // CommonFeaturesModule,
    CommonModule,
    SharedModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerImmediately'
    }),
    MatSelectModule
  ],
  providers: [
    // FormGroupDirective
    translocoLoader,
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig as TranslocoConfig,
    },
    CommunicationInterfaceService,
    LivechatStartService,
    ChatqueueService,
    MessengerService,
    FileTransferService,
    WebsocketService,
    AudiorecordingService,
    {
      provide: APP_INITIALIZER,
      useFactory: checkQueryParamsChange,
      deps: [LivechatStartService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appendSourceFiles,
      deps: [AppdataService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
